var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-option",attrs:{"data-is-label":_vm.isLabel,"data-text":_vm.text,"data-value":_vm.value}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }